// src/components/BucksAdminCustomerDetails.jsx

import React from 'react';
import '../stylings/BucksAdminCustomerDetails.css';

const BucksAdminCustomerDetails = ({ 
  customer, 
  isOpen, 
  onClose, 
  onUpdate, 
  onDelete,
  formatDate,
  formatDateTime,
  formatCurrency,
  ref
}) => {
  // Handle email customer function
  const handleEmailCustomer = () => {
    window.location.href = `mailto:${customer.email}`;
  };

  // Handle phone call
  const handlePhoneCall = () => {
    if (customer.phone) {
      window.location.href = `tel:${customer.phone}`;
    }
  };

  return (
    <div 
      className={`bucks-admin-customer-details-panel ${isOpen ? 'open' : ''}`} 
      ref={ref}
    >
      <div className="bucks-admin-customer-details-header">
        <div className="bucks-admin-customer-details-title">
          <h2>Customer Details</h2>
          <div className="bucks-admin-customer-details-id">{customer.id}</div>
        </div>
        <button 
          className="bucks-admin-customer-details-close" 
          onClick={onClose}
          aria-label="Close details panel"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div className="bucks-admin-customer-details-content">
        <div className="bucks-admin-customer-details-section">
          <div className="bucks-admin-customer-details-section-header">
            <h3>Basic Information</h3>
          </div>
          <div className="bucks-admin-customer-details-basic-info">
            <div className="bucks-admin-customer-details-avatar">
              {customer.first_name?.charAt(0) || 'C'}
            </div>
            <div className="bucks-admin-customer-details-name-contact">
              <h4>{customer.first_name} {customer.last_name}</h4>
              
              <div className="bucks-admin-customer-details-contact-buttons">
                <button onClick={handleEmailCustomer} className="bucks-admin-customer-details-email-btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  {customer.email}
                </button>
                
                {customer.phone && (
                  <button onClick={handlePhoneCall} className="bucks-admin-customer-details-phone-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    {customer.phone}
                  </button>
                )}
              </div>
              
              <div className="bucks-admin-customer-details-tags">
                {customer.tags && customer.tags.map((tag, index) => (
                  <span key={index} className="bucks-admin-customer-details-tag">{tag}</span>
                ))}
              </div>
            </div>
          </div>
          
          <div className="bucks-admin-customer-details-info-grid">
            <div className="bucks-admin-customer-details-info-row">
              <span className="bucks-admin-customer-details-label">Registration Date:</span>
              <span>{formatDate(customer.registered_at)}</span>
            </div>
            <div className="bucks-admin-customer-details-info-row">
              <span className="bucks-admin-customer-details-label">Last Order Date:</span>
              <span>{customer.last_order_date ? formatDate(customer.last_order_date) : 'No orders yet'}</span>
            </div>
            <div className="bucks-admin-customer-details-info-row">
              <span className="bucks-admin-customer-details-label">Newsletter:</span>
              <span className={`bucks-admin-customer-subscription-status ${customer.is_subscribed ? 'subscribed' : 'not-subscribed'}`}>
                {customer.is_subscribed ? 'Subscribed' : 'Not Subscribed'}
              </span>
            </div>
            <div className="bucks-admin-customer-details-info-row">
              <span className="bucks-admin-customer-details-label">Subscription Date:</span>
              <span>{customer.subscribed_at ? formatDate(customer.subscribed_at) : 'N/A'}</span>
            </div>
          </div>
        </div>
        
        {/* Customer activity summary */}
        <div className="bucks-admin-customer-details-section">
          <div className="bucks-admin-customer-details-section-header">
            <h3>Activity Summary</h3>
          </div>
          <div className="bucks-admin-customer-details-metrics">
            <div className="bucks-admin-customer-details-metric">
              <div className="bucks-admin-customer-details-metric-value">{customer.num_orders || 0}</div>
              <div className="bucks-admin-customer-details-metric-label">Orders</div>
            </div>
            <div className="bucks-admin-customer-details-metric">
              <div className="bucks-admin-customer-details-metric-value">{formatCurrency(customer.total_spent || 0)}</div>
              <div className="bucks-admin-customer-details-metric-label">Total Spent</div>
            </div>
            <div className="bucks-admin-customer-details-metric">
              {customer.num_orders > 0 ? (
                <div className="bucks-admin-customer-details-metric-value">
                  {formatCurrency(customer.total_spent / customer.num_orders)}
                </div>
              ) : (
                <div className="bucks-admin-customer-details-metric-value">$0.00</div>
              )}
              <div className="bucks-admin-customer-details-metric-label">Average Order</div>
            </div>
          </div>
        </div>
        
        {/* Address Information */}
        {customer.address && Object.keys(customer.address).length > 0 && (
          <div className="bucks-admin-customer-details-section">
            <div className="bucks-admin-customer-details-section-header">
              <h3>Shipping Address</h3>
            </div>
            <div className="bucks-admin-customer-details-address">
              <p>{customer.address.street}</p>
              <p>{customer.address.city}, {customer.address.state} {customer.address.zipcode}</p>
              
              <button className="bucks-admin-customer-details-map-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
                  <line x1="8" y1="2" x2="8" y2="18"></line>
                  <line x1="16" y1="6" x2="16" y2="22"></line>
                </svg>
                View on Map
              </button>
            </div>
          </div>
        )}
        
        {/* Order History - For customers with orders */}
        {customer.orders && customer.orders.length > 0 && (
          <div className="bucks-admin-customer-details-section">
            <div className="bucks-admin-customer-details-section-header">
              <h3>Order History</h3>
            </div>
            <div className="bucks-admin-customer-details-orders">
              <table className="bucks-admin-customer-details-table">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Items</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {customer.orders.map(order => (
                    <tr key={order.id}>
                      <td>{order.id}</td>
                      <td>{formatDate(order.created_at)}</td>
                      <td>
                        <span className={`bucks-admin-customer-details-status status-${order.status.toLowerCase().replace(' ', '-')}`}>
                          {order.status}
                        </span>
                      </td>
                      <td>{order.items.length}</td>
                      <td>{formatCurrency(order.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        
        {/* For customers with no orders */}
        {(!customer.orders || customer.orders.length === 0) && customer.num_orders === 0 && (
          <div className="bucks-admin-customer-details-section">
            <div className="bucks-admin-customer-details-section-header">
              <h3>Order History</h3>
            </div>
            <div className="bucks-admin-customer-details-no-orders">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
              <p>No orders have been placed by this customer yet.</p>
            </div>
          </div>
        )}
        
        {/* Notes Section */}
        <div className="bucks-admin-customer-details-section">
          <div className="bucks-admin-customer-details-section-header">
            <h3>Customer Notes</h3>
          </div>
          <div className="bucks-admin-customer-details-notes">
            {customer.notes ? (
              <p>{customer.notes}</p>
            ) : (
              <p className="bucks-admin-customer-details-no-notes">No notes available for this customer.</p>
            )}
          </div>
        </div>
        
        {/* For contact submissions */}
        {customer.message && (
          <div className="bucks-admin-customer-details-section">
            <div className="bucks-admin-customer-details-section-header">
              <h3>Contact Form Message</h3>
            </div>
            <div className="bucks-admin-customer-details-message">
              <div className="bucks-admin-customer-details-message-meta">
                <span className="bucks-admin-customer-details-message-subject">
                  Subject: {customer.subject || 'General Inquiry'}
                </span>
                <span className="bucks-admin-customer-details-message-time">
                  Submitted: {formatDateTime(customer.submitted_at)}
                </span>
              </div>
              <div className="bucks-admin-customer-details-message-content">
                <p>{customer.message}</p>
              </div>
              {customer.phone && (
                <div className="bucks-admin-customer-details-contact-info">
                  <strong>Phone:</strong> {customer.phone}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      
      <div className="bucks-admin-customer-details-actions">
        <button 
          className="bucks-admin-customer-details-update-btn" 
          onClick={() => onUpdate(customer)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
          </svg>
          Edit Customer
        </button>
        <button className="bucks-admin-customer-details-email-action-btn" onClick={handleEmailCustomer}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          Email Customer
        </button>
        {customer.message && onDelete && (
          <button 
            className="bucks-admin-customer-details-delete-btn" 
            onClick={() => onDelete(customer)}
            title="Delete Contact Message"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3,6 5,6 21,6"></polyline>
              <path d="M19,6l-1,14a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2L5,6m5,0V4a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2V6"></path>
            </svg>
            Delete Message
          </button>
        )}
      </div>
    </div>
  );
};

export default BucksAdminCustomerDetails;